<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="proId"
      :itemNames="['name_1','name_2']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :buttonItems="['update']"
    >
      <a-form-item slot="name_1" label="商品ID(畅联)" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productId" placeholder="请输入商品ID(畅联)"/>
      </a-form-item>
      <a-form-item slot="name_2" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productName" placeholder="请输入商品名称"/>
      </a-form-item>
      <a-button
        slot="update"
        style="margin-left: 8px"
        htmlType="submit"
        type="primary"
        @click="submitEvent"
        :loading="submitLoading"
      >全量同步(产品)
      </a-button>
    </search-page-view>
  </a-card>
</template>

<script>
import ChangLianMixins from '@/views/service/serviceProvider/changLianConnection/mixins/ChangLianMixins'

export default {
  name: 'SynchronizeProducts',
  mixins: [ChangLianMixins],
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      submitLoading: false
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getProService().post('/disney/product/all', params)
    },
    getColumns() {
      return [
        {
          title: '商品ID（畅联）',
          dataIndex: 'proProductUrl'
          // width: '150px',
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
          // width: "40%"
        },
        {
          title: '同步时间',
          dataIndex: 'proCreateTime'
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime'
        }
      ]
    },
    submitEvent() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getProService().post('/disney/synchronization', this.ruleForm).then(res => {
          this.$message.success('同步成功')
          this.$refs.pageList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
